import { useContext } from 'react';
import { CoachContext } from '../CoachProvider';

export const useCoach = () => {
    return useContext(CoachContext);
};
